import React from 'react'
import { toNumber, pick } from 'lodash-es'
import { ShowAndChangeDate } from '@ow/comps'
import { useTbViewStore } from '@vt/hooks'

// {
//   "type": "changeDate",
//   "actionType": "enforcementTime"
// }
const Calendar = function ({ config }) {
  const { setFilters, currentDate, setCurrentDate } = useTbViewStore((state) =>
    pick(state, ['setFilters', 'currentDate', 'setCurrentDate'])
  )
  const { actionType } = config

  return (
    <ShowAndChangeDate
      currentDate={currentDate}
      changeDate={(date) => {
        setCurrentDate(date)
        setFilters({
          logicType: 'and',
          queries: [
            {
              slug: actionType,
              queryType: 'dayGte',
              value: new Date(`${date}-01 00:00:00`).getTime(),
            },
            {
              slug: actionType,
              queryType: 'dayLte',
              value: new Date(
                `${date}-${new Date(
                  date.split('-')[0],
                  toNumber(date.split('-')[1]),
                  0
                ).getDate()} 23:59:59`
              ).getTime(),
            },
          ],
        })
      }}
    />
  )
}

export default Calendar
